import React, { useEffect, useState } from 'react';
import { makeStyles } from '@mui/styles';
import { CloseOutlined } from '@mui/icons-material';
import { Grid, Button, Tooltip } from '@mui/material';
import { useForm, Controller } from 'react-hook-form';
import { useTramits } from '../../../hooks/turns/useTramits';
import { useSedes } from '../../../hooks/useSedes';
import { convertirLetraMayus } from '../../../helpers/convertirLetraMayus';
import { CustomInputText } from '../../CustomInputText';
import { CustomInputSelect } from '../../CustomInputSelect';
import { Reorder } from "framer-motion";

export const CreateModuleForm = (props) => {

    const { action, sede } = props;
    const classes = useStyles();
    const [ errorTramit, setErrorTramit ] = useState(false);
    const [ tramitsModule, setTramitsModule ] = useState([]);
    const [ tramitsAvailables, setTramitsAvailables ] = useState([]);
    const { tramits } = useTramits(sede);
    const { sedes } = useSedes();
    const { handleSubmit, control, formState: { errors } } = useForm();
    const styles = useStyles();

    useEffect(() => {
        let subscribed = true;
        subscribed && setTramitsAvailables(tramits);

        return () => {
            subscribed = false;
            setTramitsAvailables([]);
        }
    }, [tramits])

    const handleClickAdd = (tramit) => {
        setTramitsAvailables((prev) => prev?.filter(t => t?.uid !== tramit?.uid));
        setTramitsModule((prev) => ([ ...prev, tramit ]));
    }

    const handleClickRemove = (tramit) => {
        setTramitsModule((prev) => prev?.filter(t => t?.uid !== tramit?.uid));
        setTramitsAvailables((prev) => ([ ...prev, tramit ]));
    }

    const onSubmit = (data) => {
        if(tramitsModule?.length <= 0) return setErrorTramit(true);

        action({
            ...data,
            tramites: tramitsModule?.map(t => t?.abreviacion?.toLowerCase())
        });
    }

    return (
        <form onSubmit={handleSubmit(onSubmit)} className={classes.form}>
            <div className={classes.formBody}>
                <Grid container spacing={2}>
                    <Grid item xs={12} md={6} lg={6}>
                        <Controller
                            name='name'
                            control={control}
                            defaultValue=''
                            render={({ field: { onChange, value } }) => (
                                <CustomInputText
                                    label='Nombre'
                                    onChange={ onChange }
                                    value={ value }
                                    error={ errors?.name }
                                />
                            )}
                            rules={{
                                required: '* Nombre obligatorio',
                                pattern: {
                                    value: /^[^\d^\s][a-zA-ZóÓ1-9 ]+[^\s]$/,
                                    message: '* Nombre incorrecto'
                                }
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} md={6} lg={6}>
                        <Controller
                            name='sede'
                            control={control}
                            defaultValue=''
                            render={({ field: { onChange, value } }) => (
                                <CustomInputSelect 
                                    label='Sede'
                                    options={sedes.map(a => ({ ...a, name: a?.nombre }))}
                                    onChange={ onChange }
                                    value={ value }
                                    error={ errors?.sede }
                                />
                            )}
                            rules={{
                                required: '* La sede es obligatoria'
                            }}
                        />
                    </Grid>
                </Grid>

                {
                    tramitsAvailables?.length > 0 && (
                        <Grid container spacing={2} marginBottom={2}>
                            <Grid item xs={ 12 }>
                                <label style={{ fontWeight: 600, fontSize: 14, paddingBottom: 10 }}>Trámites disponibles</label>
                            </Grid>
                            { tramitsAvailables?.map((tramit, index) => (
                                <Grid item key={index} xs={2}>
                                    <Tooltip title={ convertirLetraMayus(tramit?.nombre, true) }>
                                        <Button
                                            variant="outlined"
                                            size="small"
                                            className={styles.availableButton}
                                            onClick={ () => handleClickAdd(tramit) }
                                        >
                                            
                                            { tramit?.abreviacion?.toUpperCase() }
                                        </Button>
                                    </Tooltip>
                                </Grid>
                            )) }
                        </Grid>
                    ) 
                }
                
                <Grid container marginBottom={ 2 } display='block'>
                    <Grid item='true' xs={12} md={12} lg={12} paddingBottom={ 2 }>
                        <label style={{ fontWeight: 600, fontSize: 14 }}>Trámites asignados</label>
                    </Grid>

                    {  
                        tramitsModule?.length <= 0 ? (
                            <>
                                <Grid item xs={ 12 } border={ errorTramit ? '1px solid #D32F2F' : '1px solid #bdbdbd' } borderRadius={1} height={100} display='flex' justifyContent='center' alignItems='center' marginY={1}>
                                        <span style={{ fontSize: 13, color: '#bdbdbd', fontWeight: 500 }}>Vacio</span>
                                </Grid>
                                { errorTramit && <span style={{ fontSize: 12, color: '#D32F2F' }}>* Debe tener al menos un trámite asociado.</span> }
                            </>
                        ) : (
                            <div>
                                <Reorder.Group 
                                    as='div' 
                                    axis="x" 
                                    values={tramitsModule} 
                                    onReorder={ setTramitsModule } 
                                    style={{ display: 'flex', overflowY: "scroll", scrollbarWidth: 'none' }} 
                                    layoutScroll
                                >
                                    {tramitsModule.map((tramit) => (
                                        <Reorder.Item as='div' key={tramit?.uid} value={tramit}>
                                            <Tooltip title={ convertirLetraMayus(tramit?.nombre, true) } id={ tramit?.uid }>
                                                <Button
                                                    variant="outlined"
                                                    size="small"
                                                    className={styles.successButton}
                                                    endIcon={ 
                                                        <CloseOutlined
                                                            sx={{ position: 'absolute', top: 0, right: 0, fontSize: '13px !important' }} 
                                                            onClick={ () => handleClickRemove(tramit) } 
                                                        /> 
                                                    }
                                                >
                                                    { tramit?.abreviacion?.toUpperCase() }
                                                </Button>
                                            </Tooltip>
                                        </Reorder.Item>
                                    ))}
                                </Reorder.Group>
                                
                                <span style={{ fontSize: 12 }}>Mayor prioridad.</span>
                            </div>
                        )
                    }
                </Grid>
            </div>

            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                <Button
                    variant='outlined'
                    size='small'
                    className={classes.successButton}
                    type='submit'
                >
                    Crear
                </Button>
            </div>
        </form>
    )
}

const useStyles = makeStyles({
    form: {
        width: '100%',
        height: 'auto'
    },
    formBody: {
        width: '100%',
        height: '92%',
        padding: 30,
        overflowY: 'auto',
    },
    successButton: {
        background: '#00365F !important',
        color: '#fff !important',
        marginRight: '10px !important',
        marginBottom: '10px !important',
        fontWeight: 'bold !important',
        '&:hover': {
            color: '#00365F !important',
            background: '#fff !important',
            borderColor: '#00365F !important'
        }
    },
    availableButton: {
        background: '#fff !important',
        color: '#00365F !important',
        marginRight: '10px !important',
        fontWeight: 'bold !important',
        border: '1px solid #00365F !important',
        '&:hover': {
            color: '#fff !important',
            background: '#00365F !important',
            borderColor: '#fff !important'
        }
    }
});